import { Box, SxProps, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { CompletitionStatus, InfoContainer, LinearProgressCustom } from "./CarouselCard.style";
import { LEVEL, STATUS_LO } from "../../consts";
import { useNavigate } from "../../services";
import type { Level, StatusLO } from "../../types";
import { TruncatedText } from "../TruncatedText";

type IInfo = {
  title: string;
  progression: string;
  status: StatusLO;
  learningObjectTypology: Level;
  onClick?: () => void;
  sx?: SxProps;
  disabled?: boolean;
  courseId?: number;
  id: number;
  rootId?: number;
  grandParentId?: number;
}

export const Info = ({
  title,
  progression,
  onClick,
  sx,
  status,
  learningObjectTypology,
  courseId,
  id,
  rootId,
  disabled,
  grandParentId
}: IInfo) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isForYou = window.location.href.includes("per-te");
  const clampRef = useRef<HTMLElement | null>(null);

  let showProgressBar = (!!(progression && (status === STATUS_LO.P || status === STATUS_LO.C) && (learningObjectTypology === LEVEL.PATH || learningObjectTypology === LEVEL.COURSE)));

  function handleProgressionValue() {
    if (progression && progression !== "0%") {
      return Number(progression.replace("%", ""));
    }
    return 1;
  }
  
  return (
    <InfoContainer onClick={ onClick && onClick } sx={ sx }>
      <div style={ { display: "flex", alignItems: "flex-start" } }>
        <Typography fontSize="1rem" fontWeight="600"  
          sx={ {
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: "1.25rem",
            maxHeight: "2.5rem"
          } }>
          <TruncatedText
            clampRef={ clampRef }
            text={ title }
            disabled={ disabled }
            href={ navigate.getDetailLink({
              courseId, id, isForYou, learningObjectTypology, rootId: rootId ?? grandParentId
            }) }
          />
        </Typography>
      </div>
      { showProgressBar && (
        <>
          <CompletitionStatus id={ "completion-status" }>
            <Box
              sx={ {
                height: "1.44rem",
                display: "flex",
                alignItems: "center"
              } }
            >
              <Typography
                color={ theme.customColors.textPrimary }
                fontSize={ "0.75rem" }
              >
                { t("progress") }
              </Typography>
            </Box>
            
            <Typography
              color={ theme.customColors.textPrimary }
              fontSize={ "0.75rem" }
            >
              { progression ?? "0%" }
            </Typography>
          </CompletitionStatus>
          <LinearProgressCustom variant="determinate" value={ handleProgressionValue() } />
        </>
      )
      }
    </InfoContainer>
  );
};
